<template>
    <div class="d-sm-block d-none" style="width: 100%; height: 400px;">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3235.686163043781!2d51.4926044!3d35.8076372!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e0518b270a673%3A0xa54a673f904b071f!2sAjudaniye%2C%20Tajrish%2C%20Iran!5e0!3m2!1sen!2sus!4v1743325335659!5m2!1sen!2sus"
        width="400"
        height="350"
        style="border:0;"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
        </iframe>
    </div>
    <div class="d-sm-none d-block" style="width: 100%; height: 400px;">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3235.686163043781!2d51.4926044!3d35.8076372!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e0518b270a673%3A0xa54a673f904b071f!2sAjudaniye%2C%20Tajrish%2C%20Iran!5e0!3m2!1sen!2sus!4v1743325335659!5m2!1sen!2sus"
        width="250"
        height="250"
        style="border:0;"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
        </iframe>
    </div>
  </template>

<iframe ></iframe>